var parent = require('../../es/instance/bind');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/bind.js
// module id = 516
// module chunks = 0 1